import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Box,
  CircularProgress,
  Paper,
} from "@mui/material";

import { PageHeader, SubtitleM } from "../../components/Typography";
import useApiCall from "../../hooks/useApiCall";
import AgentBreadcrumbs from "../../components/AgentBreadcrumbs";

export default function AgentInsightsPage({ insightType = "user-profile" }) {
  const { id } = useParams();
  const tokens = useSelector((state) => state?.tokens.value);
  const { makeRequest } = useApiCall();

  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAgent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchAgent = async () => {
    setLoading(true);
    try {
      const agentResp = await makeRequest(`/v2/agent_instances/${id}`, {
        method: 'GET',
        authTokens: tokens,
      });
      setAgent(agentResp.agent || agentResp);
    } catch (error) {
      console.error("Error fetching agent:", error);
    } finally {
      setLoading(false);
    }
  };

  const getTitle = () => {
    switch (insightType) {
      case "user-profile":
        return "InSync User Profile";
      case "business-insights":
        return "Business Insights";
      default:
        return "Insights";
    }
  };

  const getDescription = () => {
    switch (insightType) {
      case "user-profile":
        return "View user interaction profiles and behavioral insights for this agent";
      case "business-insights":
        return "View business metrics, analytics, and performance insights for this agent";
      default:
        return "View insights and analytics";
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <AgentBreadcrumbs agentId={id} />
      <PageHeader>
        {getTitle()}: {agent?.name}
      </PageHeader>
      <SubtitleM>
        {getDescription()}
      </SubtitleM>

      <Paper sx={{ p: 4, textAlign: "center", mt: 3 }}>
        <SubtitleM style={{ fontSize: '1.2rem', color: '#666' }}>
          Coming Soon
        </SubtitleM>
        <SubtitleM style={{ marginTop: '16px', color: '#999' }}>
          This feature is under development. Agent-specific insights and analytics will be available here.
        </SubtitleM>
      </Paper>
    </>
  );
}
